<template>
    <div class="overseas-detail">
        <div v-wechat-title="overseasInfo.subtitle"></div>
        <div class="overseas-main" v-html="overseasInfo.content"></div>
        <div class="view-protocol">
            <div class="overseas-inside" v-if="source != '2'">
                <p class="overseas-adviser">详细信息咨询您的专属顾问</p>
                <!--  <a :href="'tel:' + (overseasInfo.managerInfo && overseasInfo.managerInfo.managerMobile)" class="overseas-phone" @click="telPhone(overseasInfo.managerInfo.managerMobile)"></a> -->
                <div class="overseas-phone" @click="telPhone(phone)"></div>
            </div>
            <div class="overseas-share" v-if="source == '2'">
                <div class="hpbox">
                    <img :src="overseasInfo.managerInfo.avatar" alt class="overseas-pic"/>
                </div>
                <p class="overseas-planner">
                    <span>理财师：{{ overseasInfo.managerInfo.nickName || overseasInfo.managerInfo.managerName }}</span>
                    <small>为您提供贴心专业的理财服务</small>
                </p>
                <div class="overseas-btn" @click="goRegister">打开</div>
            </div>
        </div>
    </div>
</template>
<script>
    import {bridgeRedirect, callHandler, setTitle, getUserInfo} from "../../../utils/bridge";
    import {domain} from "../../../config";
    import sensors from "sa-sdk-javascript";
    export default {
        data() {
            return {
                overseasInfo: {},
                token: "",
                title: "",
                phone: "",
                country: "",
                userId: "",
                source: 1 //来源1 内部，2外部
            };
        },
        created() {
            let params = this.$route.query;
            const {id, token, source, country, recommenderId} = params;
            this.token = decodeURIComponent(token || "");
            this.source = source;
            this.country = decodeURIComponent(country || "");
            if(source === '2'){
                this.getContent(id, recommenderId)
            }else {
                this.getPrototol(id, this.token);
            }
            this.userId = recommenderId || "";
        },
        mounted() {
            // getUserInfo().then(data => {
            //     this.userId = data.userId;
            // })
        },
        methods: {
            getPrototol: function (id, token) {
                this.$request({
                    method: "post",
                    url: `h5/goodhopesubject/detail.json`,
                    data: this.$qs.stringify({
                        id: id,
                        token: token
                    })
                })
                    .then(res => {
                        const {data} = res;
                        this.overseasInfo = data;
                        document.title = this.overseasInfo.subtitle;
                        setTitle(this.overseasInfo.subtitle);
                        this.phone = this.overseasInfo.managerInfo.managerMobile;
                        sensors.track("TMOverseasLife", {
                            product_name: this.overseasInfo.subtitle,
                            item_number: this.overseasInfo.code,
                            country: this.country
                        });

                        //右键按钮分享
                        callHandler("xhShowButton", {
                            titleBack: "1",
                            titleClose: "0",
                            titleShare: {
                                shareTitle: this.overseasInfo.name,
                                shareContent: this.overseasInfo.subdesc,
                                shareUrl: location.origin + location.pathname + `#/overseasDetail?id= ${id}&source=2&recommenderId=${this.overseasInfo.managerInfo.managerId}`,
                                shareImageUrl: this.overseasInfo.subimage,
                                sensorsAnalyticsParams: {
                                    "share_event": "分享海外生活",
                                    "entersource": "海外生活"
                                }
                            }
                        });

                    })
                    .catch(err => {
                        this.$toast(err);
                    });
            },
            getContent(id, managerId){
                this.$request({
                    method: "post",
                    url: `h5/goodhopesubject/detail`,
                    data: this.$qs.stringify({
                        id,
                        managerId
                    })
                })
                    .then(res => {
                        const {data} = res;
                        this.overseasInfo = data;
                        document.title = this.overseasInfo.subtitle;
                        setTitle(this.overseasInfo.subtitle);
                        this.phone = this.overseasInfo.managerInfo.managerMobile;
                        sensors.track("TMOverseasLife", {
                            product_name: this.overseasInfo.subtitle,
                            item_number: this.overseasInfo.code,
                            country: this.country
                        });
                    })
                    .catch(err => {
                        this.$toast(err);
                    });
            },
            goRegister() {
                window.location.href = domain.xh + `/h5static/app/planner/regCom.html?shareType=lender&activityType=invite&userId=${this.overseasInfo.managerInfo.managerId|| this.userId}`;
                // bridgeRedirect(url);
            },
            telPhone(tel) {
                callHandler("xhCallPhone", tel);
            }
        }
    };
</script>
<style lang="less">
    @import "../css/orderDetails.less";

    .overseas-detail {
        width: 100%;

        .overseas-main {
            width: 100%;
            background: #fff;
            border-radius: 20px;
            padding: 20px 16px;
            box-sizing: border-box;
            margin-bottom: 70px;
            font-size: 13px;
            color: #333333;

            p {
                font-size: 14px;
            }
        }

        img,
        p img {
            display: block;
            width: 100% !important;
            box-sizing: border-box;
        }

        /* img[src=""],
            img:not([src]) {
                opacity: 0 !important;
            } */

        .view-protocol {
            background: rgba(255, 255, 255, 0.9);
        }

        .overseas-inside {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;

            .overseas-adviser {
                font-size: 15px;
                color: #333333;
            }

            .overseas-phone {
                background: url(../../.././assets/images/normal/adviser_phone.png) no-repeat;
                background-size: 100% 100%;
                display: inline-block;
                width: 32px;
                height: 32px;
                margin-left: 10px;
            }
        }

        .overseas-share {
            width: 100%;
            display: flex;
            justify-content: space-around;
            padding: 0px 10px;
            box-sizing: border-box;
            align-items: center;

            .hpbox {
                display: flex;
                width: 44px;
                height: 44px;
                border-radius: 50%;
                background: #fff;
                overflow: hidden;
                border: 2px solid #c0a266;
                justify-content: center;
                align-items: center;
            }

            .overseas-pic {
                display: inline-block;
                width: 48px;
                height: 48px;
                border-radius: 50%;
            }

            p {
                span {
                    font-size: 14px;
                    color: #333333;
                    display: block;
                    line-height: 28px;
                }

                small {
                    display: block;
                    line-height: 18px;
                    font-size: 13px;
                    color: #aaaaaa;
                }
            }

            .overseas-btn {
                background-image: linear-gradient(90deg, #e0cb99 0%, #bd9c60 100%);
                border-radius: 20px;
                font-size: 13px;
                color: #ffffff;
                display: inline-block;
                width: 72px;
                height: 32px;
                line-height: 32px;
                text-align: center;
            }
        }
    }
</style>
